"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Collapse, SimpleGrid, UnstyledButton} from "@mantine/core";
import OrgLinkLine from "@/app/(index)/organization/org-link-line";
import Image from "next/image";
import {loadOrganizationGroupData} from "@/service";
import {ITeamListDTO} from "@/form/group";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {useDisclosure, useMediaQuery} from "@mantine/hooks";
import {IconChevronDown, IconChevronUp, IconLink} from '@tabler/icons-react';


const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});


const Page = ({ params }: { params: { tid: string } }) => {
    const { fontSize, lang } = useGlobalStateStore();
    const [tab, setTab] = useState<string>(params.tid);
    const [groupData, setGroupData] = useState<{[key: string]: ITeamListDTO[]}>({});
    const [openedA, { toggle: toggleA }] = useDisclosure(false);
    const [openedB, { toggle: toggleB }] = useDisclosure(false);
    const [openedC, { toggle: toggleC }] = useDisclosure(false);
    const [openedD, { toggle: toggleD }] = useDisclosure(false);


    useEffect(() => {
        loadOrganizationGroupData().then(data => {
            setGroupData(data);
            if (!data[params.tid]) {
                const firstVisible = ['A', 'B', 'C', 'D'].find(key => data[key]);
                if (firstVisible) {
                    setTab(firstVisible);
                }
            }
        })
    }, [params.tid]);

    const isVisible = (key: string) => Object.prototype.hasOwnProperty.call(groupData, key);



    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>

                {
                    mediaQueryLessSM && (
                        <Bread name_c="關於科政中心 - 組織架構" name_e="About STPI - Organization"/>
                    )
                }


                <div className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        { lang == "tw" ? "組織架構" : "Organization" }
                    </div>


                    <div className="flex flex-col items-center w-full">
                        <UnstyledButton component="a" href={ lang == "tw" ? "https://www.narlabs.org.tw/" : "https://www.niar.org.tw/en"}>
                            <div
                                className={cx("border border-[#69a7a3] hover:bg-[#69a7a3]/30 text-[25px] font-bold rounded-[60px] py-[15px] w-[360px] flex justify-center")}>
                                <Image
                                    width={120}
                                    height={120}
                                    src={lang == "tw" ? "/images/niar-logo1.svg" : "/images/niar-en.svg"}
                                    alt="Niar Logo"
                                />
                            </div>
                        </UnstyledButton>
                        <OrgLinkLine/>
                        <UnstyledButton component="a" href={ lang == "tw" ? "https://www.stpi.niar.org.tw/" : "https://www.stpi.niar.org.tw/en"}>
                            <div
                                className="border border-[#69a7a3] hover:bg-[#69a7a3]/30 text-[25px] font-bold rounded-[60px] py-[15px] w-[360px] flex justify-center">
                                <Image
                                    width={lang == "tw" ? 200 : 300}
                                    height={200}
                                    src={lang == "tw" ? "/images/stpi-logo.svg" : "/images/stpi-logo-en.svg"}
                                    alt="Niar Logo"
                                />
                            </div>
                        </UnstyledButton>
                        <OrgLinkLine/>
                        <UnstyledButton component="a" href={"/leader"}>
                            <div
                                className="border border-[#69a7a3] hover:bg-[#69a7a3]/30 text-[25px] font-bold rounded-[60px] py-[15px] w-[360px] text-center">
                                {lang == "tw" ? "主任" : "Director General"}
                            </div>
                        </UnstyledButton>
                        <OrgLinkLine/>
                        <UnstyledButton component="a" href={"/leader/Deputy-Director-General"}>
                            <div
                                className="border border-[#69a7a3] hover:bg-[#69a7a3]/30 text-[25px] font-bold rounded-[60px] py-[15px] w-[360px] text-center">
                                {lang == "tw" ? "副主任" : "Deputy Director General"}
                            </div>
                        </UnstyledButton>
                        <OrgLinkLine/>
                    </div>

                    {
                        !mediaQueryLessSM && (
                            <>

                                <div className="w-[360px] flex flex-col mx-auto items-end gap-5">
                                    {isVisible('A') && (
                                        <div className="bg-[#699fbb] rounded-xl">
                                            <UnstyledButton onClick={toggleA}>
                                                <div
                                                    className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#4a809c] flex justify-between items-center")}>
                                                    <div>
                                                        { lang == "tw" ? "政策研究組" : "Policy Research Division" }
                                                    </div>
                                                    <div className="pe-3">
                                                        { openedA ? <IconChevronUp/> : <IconChevronDown/> }
                                                    </div>
                                                </div>
                                            </UnstyledButton>
                                            <Collapse in={openedA}>
                                                <div className="flex flex-col gap-2 px-5 py-3">
                                                    {
                                                        groupData['A']?.map((item) => (
                                                            <UnstyledButton component="a" href={`/group/${tab}/${item.temId}`} key={`mb-${item.temId}`}>
                                                                <div className="text-[#c2e1f1] text-[20px] font-bold">
                                                                    { lang == "tw" ? item.name : item.nameEn}
                                                                </div>
                                                            </UnstyledButton>
                                                        ))
                                                    }
                                                </div>
                                            </Collapse>
                                        </div>
                                    )}

                                    {isVisible('B') && (
                                        <div className="bg-[#699fbb] rounded-xl">
                                            <UnstyledButton onClick={toggleB}>
                                                <div
                                                    className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#4a809c] flex justify-between items-center")}>
                                                    <div>
                                                        {lang == "tw" ? "科研資料組" : "Database & Information Service Division"}
                                                    </div>
                                                    <div className="pe-3">
                                                        { openedB ? <IconChevronUp/> : <IconChevronDown/> }
                                                    </div>
                                                </div>
                                            </UnstyledButton>
                                            <Collapse in={openedB}>
                                                <div className="flex flex-col gap-2 px-5 py-3">
                                                    {
                                                        groupData['B']?.map((item) => (
                                                            <UnstyledButton component="a" href={`/group/${tab}/${item.temId}`} key={`mb-${item.temId}`}>
                                                                <div className="text-[#c2e1f1] text-[20px] font-bold">
                                                                    { lang == "tw" ? item.name : item.nameEn}
                                                                </div>
                                                            </UnstyledButton>
                                                        ))
                                                    }
                                                </div>
                                            </Collapse>
                                        </div>
                                    )}

                                    {isVisible('C') && (
                                        <div className="bg-[#699fbb] rounded-xl">
                                            <UnstyledButton onClick={toggleC}>
                                                <div
                                                    className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#4a809c] flex justify-between items-center")}>
                                                    <div>
                                                        { lang == "tw" ? "科產推動組" : "S & T Industry Division" }
                                                    </div>
                                                    <div className="pe-3">
                                                        { openedC ? <IconChevronUp/> : <IconChevronDown/> }
                                                    </div>
                                                </div>
                                            </UnstyledButton>
                                            <Collapse in={openedC}>
                                                <div className="flex flex-col gap-2 px-5 py-3">
                                                    {
                                                        groupData['C']?.map((item) => (
                                                            <UnstyledButton component="a" href={`/group/${tab}/${item.temId}`} key={`mb-${item.temId}`}>
                                                                <div className="text-[#c2e1f1] text-[20px] font-bold">
                                                                    { lang == "tw" ? item.name : item.nameEn}
                                                                </div>
                                                            </UnstyledButton>
                                                        ))
                                                    }
                                                </div>
                                            </Collapse>
                                        </div>
                                    )}


                                    {isVisible('D') && (
                                        <div className="bg-[#699fbb] rounded-xl">
                                            <UnstyledButton onClick={toggleD}>
                                                <div
                                                    className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#4a809c] flex justify-between items-center")}>
                                                    <div>
                                                        { lang == "tw" ? "創新創業推動組" : "Innovation & Entrepreneurship Promotion Division" }
                                                    </div>
                                                    <div className="pe-3">
                                                        { openedD ? <IconChevronUp/> : <IconChevronDown/> }
                                                    </div>
                                                </div>
                                            </UnstyledButton>
                                            <Collapse in={openedD}>
                                                <div className="flex flex-col gap-2 px-5 py-3">
                                                    {
                                                        groupData['D']?.map((item) => (
                                                            <UnstyledButton component="a" href={`/group/${tab}/${item.temId}`} key={`mb-${item.temId}`}>
                                                                <div className="text-[#c2e1f1] text-[20px] font-bold">
                                                                    { lang == "tw" ? item.name : item.nameEn}
                                                                </div>
                                                            </UnstyledButton>
                                                        ))
                                                    }
                                                </div>
                                            </Collapse>
                                        </div>
                                    )}

                                    <UnstyledButton onClick={toggleD}>
                                        <div
                                            className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#a8bb6a] flex justify-between items-center")}>
                                            <div>
                                                { lang == "tw" ? "資訊系統組" : "Information Management Division" }
                                            </div>
                                            <div className="pe-3">
                                                <IconLink/>
                                            </div>
                                        </div>
                                    </UnstyledButton>
                                    <div
                                        className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#b0a287]")}>
                                        {lang == "tw" ? "企劃推廣組" : "Administration Division"}
                                    </div>
                                    <div
                                        className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#b0a287]")}>
                                        {lang == "tw" ? "行政服務組" : "Planning & Promotion Division"}
                                    </div>
                                    <div
                                        className={cx("py-[10px] w-[320px] text-white h-full rounded-xl ps-5 bg-[#b0a287]")}>
                                        { lang == "tw" ? "財會小組" : "Finance & Accounting Division" }
                                    </div>
                                </div>
                            </>
                        )
                    }

                    {
                        mediaQueryLessSM && (() => {
                            const type1Cells = (['A', 'B', 'C', 'D'] as const)
                                .filter(isVisible)
                                .map(key => ({
                                    kind: 'type1' as const,
                                    key,
                                    label: {
                                        A: ['政策研究組', 'Policy Research Division'],
                                        B: ['科研資料組', 'Database & Information Service Division'],
                                        C: ['科產推動組', 'S & T Industry Division'],
                                        D: ['創新創業推動組', 'Innovation & Entrepreneurship Promotion Division'],
                                    }[key],
                                }));
                            const orgCells: Array<
                                | { kind: 'type1'; key: 'A' | 'B' | 'C' | 'D'; label: string[] }
                                | { kind: 'IT' | 'PLAN' | 'ADMIN' | 'FIN'; label: string[]; bg: string }
                            > = [
                                ...type1Cells,
                                { kind: 'IT', label: ['資訊系統組', 'Information Management Division'], bg: 'bg-[#a8bb6a]' },
                                { kind: 'PLAN', label: ['企劃推廣組', 'Administration Division'], bg: 'bg-[#b0a287]' },
                                { kind: 'ADMIN', label: ['行政服務組', 'Planning & Promotion Division'], bg: 'bg-[#b0a287]' },
                                { kind: 'FIN', label: ['財會小組', 'Finance & Accounting Division'], bg: 'bg-[#b0a287]' },
                            ];
                            return (
                                <>
                                    <div className="flex gap-1">
                                        {orgCells.map((_, idx) => (
                                            <div key={`line-${idx}`} className="flex-1 flex">
                                                <div className={cx("bg-[url('/images/orgLine-2.png')] bg-repeat-x h-[2px] w-1/2", idx === 0 && "invisible")} />
                                                <div className={cx("bg-[url('/images/orgLine-2.png')] bg-repeat-x h-[2px] w-1/2", idx === orgCells.length - 1 && "invisible")} />
                                            </div>
                                        ))}
                                    </div>

                                    <div className="flex gap-1 text-center font-bold text-[18px] text-white ">
                                        {orgCells.map((cell, idx) => {
                                            if (cell.kind === 'type1') {
                                                return (
                                                    <div key={`tab-${cell.key}`}
                                                         className={cx("flex flex-col flex-1 items-center", {"cursor-pointer": tab !== cell.key})}
                                                         onClick={() => setTab(cell.key)}>
                                                        <OrgLinkLine/>
                                                        <div className={cx("py-[16px] w-full h-full", tab === cell.key ? "bg-[#4a809c]" : "bg-[#699fbb]")}>
                                                            { lang == "tw" ? cell.label[0] : cell.label[1] }
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            return (
                                                <div key={`tab-${cell.kind}`} className="flex flex-col flex-1 items-center">
                                                    <OrgLinkLine/>
                                                    <div className={cx("py-[16px] w-full h-full", cell.bg)}>
                                                        {cell.kind === 'IT' ? (
                                                            <UnstyledButton component="a" href={"/group/IT"}>
                                                                { lang == "tw" ? cell.label[0] : cell.label[1] }
                                                            </UnstyledButton>
                                                        ) : (
                                                            <>{ lang == "tw" ? cell.label[0] : cell.label[1] }</>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div className={cx("w-full bg-[#4a809c] py-[45px] px-[60px]")}>
                                        <SimpleGrid cols={2}>
                                            {
                                                groupData[tab]?.map((item) => (
                                                    <UnstyledButton component="a" href={`/group/${tab}/${item.temId}`} key={`pc-${item.temId}`}>
                                                        <div className="text-[#c2e1f1] text-[20px] font-bold">
                                                            { lang == "tw" ? item.name : item.nameEn}
                                                        </div>
                                                    </UnstyledButton>
                                                ))
                                            }
                                        </SimpleGrid>
                                    </div>
                                </>
                            );
                        })()
                    }
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Page
